import { render, staticRenderFns } from "./CouponSection.vue?vue&type=template&id=be0a7a02&scoped=true&"
import script from "./CouponSection.vue?vue&type=script&lang=js&"
export * from "./CouponSection.vue?vue&type=script&lang=js&"
import style0 from "./CouponSection.vue?vue&type=style&index=0&id=be0a7a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0a7a02",
  null
  
)

/* custom blocks */
import block0 from "./CouponSection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports